// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"301":"7c9565e9","453":"26665d3b","980":"4a536c0e"}[chunkId] + ".chunk.js";
};